import React, { useState, useEffect } from 'react';
import { api } from '../../utils/api';
import {
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Box,
  Alert,
  InputAdornment
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import { useAuth } from '../../contexts/AuthContext';

const LaborSettings = () => {
  const { user } = useAuth();
  const companyId = user?.companyId;
  const [laborHourlyRate, setLaborHourlyRate] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (!companyId) return;
    const fetchLaborRate = async () => {
      try {
        const res = await api.get('/company-settings');
        if (res.data && res.data.laborHourlyRate) {
          setLaborHourlyRate(res.data.laborHourlyRate.toString());
        } else {
          setLaborHourlyRate('30.00');
        }
      } catch (err) {
        console.error('Error fetching labor rate:', err);
        setError('Errore nel caricamento della tariffa oraria');
        setLaborHourlyRate('30.00');
      }
    };
    fetchLaborRate();
  }, [companyId]);

  const handleChange = (e) => {
    setLaborHourlyRate(e.target.value);
    setError(null);
    setSuccess(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(false);

    try {
      await api.patch('/company-settings', {
        laborHourlyRate: parseFloat(laborHourlyRate)
      });
      setSuccess(true);
      window.dispatchEvent(new Event('laborRateUpdated'));
      setTimeout(() => {
        setSuccess(false);
      }, 3000);
    } catch (err) {
      console.error('Error saving labor rate:', err);
      setError('Errore nel salvataggio della tariffa oraria');
    }
  };

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Tariffa Oraria Manodopera
        </Typography>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
          <TextField
            label="Tariffa Oraria"
            type="number"
            value={laborHourlyRate}
            onChange={handleChange}
            fullWidth
            required
            InputProps={{
              startAdornment: <InputAdornment position="start">€</InputAdornment>,
              inputProps: { min: 0, step: 0.01 }
            }}
          />
          <Box sx={{ mt: 2, display: 'flex', gap: 2, alignItems: 'center' }}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
            >
              Salva
            </Button>
            {error && <Alert severity="error">{error}</Alert>}
            {success && (
              <Alert severity="success">
                Tariffa oraria aggiornata con successo
              </Alert>
            )}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default LaborSettings;